<template>
  <svg :class="className" xmlns="http://www.w3.org/2000/svg">
    <use
      v-if="iconPath"
      :xlink:href="iconPath"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    />
  </svg>
</template>

<script>
export default {
  name: 'svgIcon',

  props: {
    name: {},
  },

  computed: {
    iconPath() {
      const { name } = this;

      if (!name) return null;

      let icon = require(`@/assets/svg/sprite/${name}.svg`);

      if (Object.prototype.hasOwnProperty.call(icon, 'default')) {
        icon = icon.default;
      }

      const result = icon.url;

      return result;
    },

    className() {
      const { name } = this;
      const result = { 'svg-icon': true, [`svg-icon--${name}`]: true };

      return result;
    },
  },
};
</script>

<style>
.svg-icon {
  fill: currentColor;
  height: 24px;
  width: 24px;
}
</style>
